import React, { useState } from "react";
import one from "assets/images/flus/one.png";
import two from "assets/images/flus/two.png";
import three from "assets/images/flus/three.png";
import selectedThree from "assets/images/flus/selected-three-que.png";
import selectedOne from "assets/images/flus/Selected-one-que.png";
import selectedTwo from "assets/images/flus/selected-two-que.png";
import { motion } from "framer-motion/dist/framer-motion";
import {
  divVariants,
  staticBounceVariants
} from "shared/components/animations";
const FlusterVoteCard = ({ onClick = () => {} }) => {
  const [selectedImage, setSelectedImage] = useState(1);

  const handleClick = (imageNumber) => {
    setSelectedImage(imageNumber);
    onClick(imageNumber);
  };

  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="vote-points"
    >
      <motion.div
        variants={staticBounceVariants}
        className="text-center vote-div"
      >
        <img
          src={selectedImage === 1 ? selectedOne : one}
          className="image"
          alt="One"
          onClick={() => handleClick(1)}
        />
      </motion.div>
      <motion.div
        variants={staticBounceVariants}
        className="text-center vote-div"
      >
        <img
          src={selectedImage === 2 ? selectedTwo : two}
          className="image"
          alt="Two"
          onClick={() => handleClick(2)}
        />
      </motion.div>
      <motion.div
        variants={staticBounceVariants}
        className="text-center vote-div"
      >
        <img
          src={selectedImage === 3 ? selectedThree : three}
          className="image"
          alt="Three"
          onClick={() => handleClick(3)}
        />
      </motion.div>
    </motion.div>
  );
};

export default FlusterVoteCard;
